import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import TableResponsiveToggle from '../../TableResponsiveToggle';
const TableCell = ({ className, children, descriptor, responsiveMode, responsiveToggle, onResponsiveClick = ()=>{}, tableWrapper, typeOpen, responsivePriority, ...other })=>{
    if (responsiveMode) {
        if (!descriptor) {
            return null;
        }
        const spanStyle = {
            padding: '3px',
            margin: '0px 10px 5px 0px',
            display: descriptor.visible ? 'none' : 'inline-block'
        };
        return /*#__PURE__*/ React.createElement("span", {
            style: spanStyle,
            className: cx('Table-cell-responsive', className),
            ...other
        }, /*#__PURE__*/ React.createElement("strong", null, descriptor.title), ": ", children);
    } else {
        return /*#__PURE__*/ React.createElement("td", {
            style: {
                display: !descriptor || descriptor.visible ? 'table-cell' : 'none'
            },
            className: cx('Table-cell', className, {
                'Table-cell--tableWrapper': tableWrapper,
                'Table-cell--opened': typeOpen,
                'Table-cell--typeToggle': !!responsiveToggle
            }),
            ...other
        }, responsiveToggle ? /*#__PURE__*/ React.createElement(TableResponsiveToggle, {
            onClick: onResponsiveClick
        }) : null, children);
    }
};
TableCell.propTypes = {
    /**
	 * Children will be rendered within the `TableCell`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Cell colspan
	 */ colSpan: PropTypes.number,
    /**
	 * Column descriptor only for this cell.
	 */ descriptor: PropTypes.object,
    /**
	 * Handler for toggle button to show/hide hidden columns.
	 *
	 * @return {undefined}
	 */ onResponsiveClick: PropTypes.func,
    /**
	 * Switch between visible column or hidden column in special responsive row which is show/hidden by toggle button.
	 */ responsiveMode: PropTypes.bool,
    /**
	 * Decide priority of column hiding. By default 20 for last column and 10 for all the other columns. Higher number means higher priority to show. Relevant only for cells inside TableHead.
	 */ responsivePriority: PropTypes.number,
    /**
	 * If included, will 'prepend' or 'append' the responsive row toggle button. Toggle button is visible only when some columns are hidden (due to short width), clicking it will reveal those columns on new line.
	 */ responsiveToggle: PropTypes.oneOf([
        'prepend',
        'append'
    ]),
    /**
	 * Cell rowspan.
	 */ rowSpan: PropTypes.number,
    /**
	 * Table will have `Table-cell--tableWrapper` class.
	 */ tableWrapper: PropTypes.bool,
    /**
	 * Table will have `Table-cell--opened` class.
	 */ typeOpen: PropTypes.bool
};
TableCell.displayName = 'TableCell';
export default TableCell;
